import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { CurtainImage, RevealBlock } from "@/components/RevealEffects";
import nutritionImg from "@/assets/program-nutrition.webp";
import trainingHeroAsset from "@/assets/physical-training-hero.png.asset.json";
import trainingHeroDesktopAsset from "@/assets/physical-training-skyline.webp.asset.json";
import retreatHeroAsset from "@/assets/retreat-hero.png.asset.json";

const programs = [
  { eyebrow: "Nutrition", title: <>Nutrition &amp; <span className="text-nav-cta">Culinary Wellness</span></>, exploreLabel: "Nutrition", description: "We begin with the way you actually eat, then build a whole-food approach that supports metabolic stability, digestive health, energy, and sustainable weight management. Culinary coaching turns nutrition into something you can shop for, prepare, and repeat in daily life.", image: nutritionImg, link: "/nutrition" },
  { eyebrow: "Movement", title: <>Physical Activity <span className="text-nav-cta">Training</span></>, exploreLabel: "Training", description: "Movement introduced in ways that are useful beyond a workout - walking with purpose, carrying, reaching, balancing, rising, climbing, and building whole-body strength. Available remotely, in person throughout San Diego, or within an immersive retreat experience.", image: trainingHeroAsset.url, desktopImage: trainingHeroDesktopAsset.url, link: "/physical-activity-training", objectPosition: "50% center" },
  { eyebrow: "Retreats", title: <><span className="text-nav-cta">Luxury Lifestyle</span> Wellness Retreats</>, exploreLabel: "Retreats", description: "A private, restorative environment for meaningful change. Whole-food culinary wellness, outdoor movement, cardiometabolic coaching, recovery, and stress regulation woven into a personalized experience - with one full year of complimentary remote coaching included.", image: retreatHeroAsset.url, link: "/retreats", objectPosition: "left center" },
];

const ProgramsSection = () => (
  <section id="programs" className="bg-background pt-20 md:pt-32 lg:pt-40 pb-12 md:pb-16 overflow-hidden">
    <RevealBlock variant="rise" className="mx-auto max-w-7xl px-6 md:px-12 lg:px-[100px]">
      <p className="eyebrow mb-5 text-nav-cta">Explore</p>
      <h2 className="max-w-3xl text-foreground">Personalized <span className="text-nav-cta">Health Programs</span></h2>
    </RevealBlock>

    <div className="mx-auto mt-16 max-w-[1496px] space-y-24 px-6 md:mt-24 md:space-y-40 md:px-12 lg:px-[100px]">
      {programs.map((p, index) => (
        <RevealBlock key={p.exploreLabel} as="article" index={index} className="relative">
          <CurtainImage
            src={p.image}
            desktopSrc={p.desktopImage}
            alt={p.exploreLabel}
            objectPosition={p.objectPosition}
            wrapperClass={`w-full md:w-[76%] ${index % 2 ? "md:ml-auto" : ""}`}
            className="h-[430px] w-full object-cover md:aspect-[1296/710] md:h-auto"
          />
          <RevealBlock
            variant="rise"
            index={1}
            className={`relative -mt-20 w-[92%] bg-secondary px-7 py-9 md:absolute md:bottom-[-70px] md:mt-0 md:w-[550px] md:px-10 md:py-10 ${index % 2 ? "md:left-0" : "md:right-0 ml-auto md:ml-0"}`}
          >
            <p className="eyebrow mb-3 text-nav-cta">{p.eyebrow}</p>
            <h3 className="mb-4 text-foreground">{p.title}</h3>
            <p className="mb-7 text-muted-foreground">{p.description}</p>
            <Button variant="outline" size="lg" className="w-fit" asChild>
              <Link to={p.link}>Explore {p.exploreLabel}<ArrowRight size={16} className="ml-2" /></Link>
            </Button>
          </RevealBlock>
        </RevealBlock>
      ))}
    </div>
  </section>
);

export default ProgramsSection;
